<template>
	<div
		class="bookmarks-shortcut-skeleton"
		:aria-label="$t('spa__general.loading')"
	>
		<SuiSkeleton width="90%" class="bookmarks-shortcut-skeleton__item" />
		<SuiSkeleton width="60%" class="bookmarks-shortcut-skeleton__item" />
		<SuiSkeleton width="70%" class="bookmarks-shortcut-skeleton__item" />
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SuiSkeleton } from '@developers/scoro-ui';

export default defineComponent({
	components: {
		SuiSkeleton,
	},
});
</script>

<style lang="scss" scoped>
.bookmarks-shortcut-skeleton {
	padding: 1.25rem 2rem 1.25rem 1.5rem;

	&__item {
		height: 1.5rem;

		&:not(:last-child) {
			margin-bottom: 2.5rem;
		}
	}
}
</style>
